const hostname = window && window.location && window.location.hostname;

export const host_url = `${process.env.REACT_APP_BACKEND_HOST}api/`,
  microService_url = `${process.env.REACT_APP_MICROSERVICE_HOST}`,
  host_name = `${hostname}`,
  asset_url = `${process.env.REACT_APP_ASSET_HOST}/`,
  google_key = `${process.env.REACT_APP_GOOGLE_KEY}`,
  store_url = `${process.env.REACT_APP_STORE_URL}`,
  sendbird_AdminId = `${process.env.REACT_APP_SENDBIRD_ADMIN_ID}`,
  sendbird_id = `${process.env.REACT_APP_SENDBIRD_APP_ID}`,
  sendbird_token = `${process.env.REACT_APP_SENDBIRD_API_TOKEN}`;
